import { Button, Typography } from "antd";
import { PlusOutlined } from "@ant-design/icons";

const { Text } = Typography;

interface Props {
  description: string;
  buttonText?: string;
  onAdd: () => void;
}

export const ConfigSectionHeader: React.FC<Props> = ({
  description,
  buttonText = "Add Config",
  onAdd,
}) => (
  <div className="flex justify-between items-center bg-gray-50 p-2.5 rounded-lg border">
    <Text className="text-xs text-gray-500">{description}</Text>
    <Button
      type="primary"
      icon={<PlusOutlined />}
      onClick={onAdd}
      size="small"
      className="!bg-black !border-black hover:!bg-gray-800 text-xs"
    >
      {buttonText}
    </Button>
  </div>
);
